import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterModule } from '@angular/router';
import { INavigation } from '../../../interfaces/interface';

@Component({
  selector: 'app-sub-sidebar',
  standalone: true,
  imports: [CommonModule,TranslocoModule, RouterModule],
  templateUrl: './sub-sidebar.component.html',
  styleUrls: ['./sub-sidebar.component.scss'],
})
export class SubSidebarComponent implements OnInit {
  @Input() item!: INavigation;
  @Input() clinicUrl: string = '';
  @Input() index!: number;
  @Input() depth!: number;
  @Input() set depthVal(e: number) {
    if (e || e == 0) this.depth = e;
  }
  @Output() expand = new EventEmitter();
  @Output() expandSublevel = new EventEmitter();
  expanded: boolean = false;
  constructor() {}

  ngOnInit(): void {}

  onItemSelected(item: INavigation, index: number, depth: number) {
    if (item.sublist && item.sublist.length) item.expanded = !item.expanded;
    this.expand.emit({ item: item, index: index, depth: depth });
  }
}
